import { render, staticRenderFns } from "./_UsersPage.vue?vue&type=template&id=70903d1a&"
import script from "./_UsersPage.vue?vue&type=script&lang=ts&"
export * from "./_UsersPage.vue?vue&type=script&lang=ts&"
import style0 from "./_UsersPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports